<div class="not-found-wrapper">
  <div class="not-found-card">
    <h1 class="error-code">404</h1>

    <div class="divider"></div>

    <h2 class="subtitle">Page not found</h2>
    <p class="description">
      The page you're looking for doesn't exist or has been moved.
    </p>

    <a routerLink="/" class="home-btn">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
      Back to Home
    </a>
  </div>
</div>
